import tempMeeApi from '../../../apis/tempMee';

// Endpoint #7 — the per-professional promotion payout history.
export const getProfessionalPromotionPayouts = async (professionalId) => {
  const response = await tempMeeApi.get(
    `/payment/admin/professionals/${professionalId}/promotion-payouts`,
  );

  return response.data;
};
